const DRAGHANDLE_HEIGHT = 68;
const TOPBAR_HEIGHT = 68;
const BOTTOM_MARGIN = 24;
const WIDGET_SETTINGS_WIDTH = 464;
const WIDGET_SETTINGS_COLLAPSED_WIDTH = 350;
const WIDGET_SETTINGS_MAXHEIGHT = 684;

function DraggableWindowDirective($timeout, $rootScope) {
    'ngInject';
    function link(scope, el, attrs) {
        $timeout(() => {
            $rootScope.$on('draggable-window-reset', () => {
                el[0].style.bottom = '24px';
                el[0].style.right = '24px';
                el[0].style.left = 'auto';
                el[0].style.top = 'auto';
                el[0].style.maxHeight = ``;
                el[0].style.minHeight = ``;
                
            });

            const handle = el.find(attrs.draggableWindowHandle);

            handle[0].onmousedown = function (event) {
                const isComponentSettingsReduced = scope.$parent.vm.isComponentSettingsReduced;
                const isLeftClick = event.button === 0;
                if (!isLeftClick) return;
                let shiftX = event.clientX - el[0].getBoundingClientRect().left;
                let shiftY = event.clientY - el[0].getBoundingClientRect().top;

                function moveAt(clientX, clientY) {
                    const newWindowLeft = clientX - shiftX;
                    const newWindowTop = clientY - shiftY;
                    el[0].style.bottom = 'auto';
                    el[0].style.right = 'auto';
                    el[0].style.left = `min(max(${newWindowLeft}px, 0px), 100% - ${
                        isComponentSettingsReduced ? WIDGET_SETTINGS_COLLAPSED_WIDTH : WIDGET_SETTINGS_WIDTH
                    }px)`;
                    el[0].style.top = `max(${newWindowTop}px, ${TOPBAR_HEIGHT}px)`;
                    el[0].style.maxHeight = `min(${WIDGET_SETTINGS_MAXHEIGHT}px, 100% - ${BOTTOM_MARGIN}px - ${
                        newWindowTop + 'px'
                    } )`;
                    el[0].style.minHeight = `${DRAGHANDLE_HEIGHT}px`;
                }

                moveAt(event.clientX, event.clientY);

                function onMouseMove(event) {
                    moveAt(event.clientX, event.clientY);
                }

                document.addEventListener('mousemove', onMouseMove);

                function stopDrag() {
                    document.removeEventListener('mousemove', onMouseMove);
                    handle[0].onmouseup = null;
                }

                handle[0].onmouseup = function () {
                    stopDrag();
                };
                document.body.addEventListener('mouseleave', stopDrag);
            };

            handle[0].ondragstart = function () {
                return false;
            };
        });
    }

    return {
        link: link,
    };
}

/////////////////////////////

angular.module('Directives').directive('draggableWindow', DraggableWindowDirective);

/////////////////////////////

export { DraggableWindowDirective };
